(ns manage.adset-decision-tree-page.view.context
  (:require [cljs-bean.core :refer [->clj]]
            [common.flags :refer [use-flags]]
            [common.queries :refer [use-query]]
            [common.resource.query.decision-tree :as queries]
            [common.resource.query.schema :refer [use-schemas]]
            [manage.adset-decision-tree-page.node-library :as node-library]
            [manage.adset-decision-tree-page.property :as property]
            [manage.adset-decision-tree-page.selection :as selection]
            [manage.adset-decision-tree-page.sub :as sub]
            [manage.adset-decision-tree-page.validation :as validation]
            [manage.adset.hooks :refer [use-channel]]
            [mate.core :as mc]
            [uix.core :as uix :refer [$ defui defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(def decision-trees-context
  (uix/create-context nil))

(defn has-newer-revisions? [decision-tree-data]
  (->> decision-tree-data ->clj :data :nodes (mapcat :ad-variants)
       sub/some-ready-for-update?))

(defn has-archived-variants? [decision-tree-data]
  (->> decision-tree-data ->clj :data :nodes (mapcat :ad-variants)
       sub/some-archived-variants?))

(defhook use-properties-context [available-nodes]
  (let [properties (uix/use-memo #(concat (mapcat :properties available-nodes)
                                          property/ad-variant-properties)
                                 [available-nodes])
        root-node (use-subscribe [::sub/root-node-data])
        schema-ids (uix/use-memo
                    #(->> properties (map (comp :schema-urn :context)) (remove nil?) set)
                    [properties])
        schemas (use-schemas schema-ids)]
    (uix/use-memo #(when (= (count schemas) (count schema-ids))
                     (mc/index-by identity
                                  (fn [context]
                                    (case (:type context)
                                      :root-node root-node
                                      :predicate-schema (get schemas (:schema-urn context))))
                                  (keep :context properties)))
                  [schemas schema-ids properties root-node])))

(defhook use-available-nodes []
  (let [current-channel (use-channel)
        flag-values (use-flags selection/feature-flags)]
    (uix/use-memo #(filterv (fn [{:keys [deprecated adset-channel palette feature-flag]
                                  :or {palette true}}]
                              (and (not deprecated)
                                   palette
                                   (or (empty? adset-channel)
                                       (contains? adset-channel current-channel))
                                   (or (nil? feature-flag)
                                       (get flag-values feature-flag))))
                            node-library/nodes)
                  [current-channel flag-values])))

(defhook use-property-context [property]
  (let [{:keys [properties-context]} (uix/use-context decision-trees-context)]
    (get properties-context (:context property))))

(defui with-decision-tree-context [{:keys [children]}]
  (let [{:keys [advertiser-id adset-id]} (use-subscribe [:url-context])
        {{decision-trees :data} :data
         :keys [isSuccess isStale]} (use-query (queries/fetch-decision-trees-query
                                                {:advertiser-id advertiser-id
                                                 :adset-id adset-id}))
        draft-decision-tree (some (fn [{:keys [status] :as dt}]
                                    (when (= status "draft")
                                      dt))
                                  decision-trees)
        published-decision-tree (some (fn [{:keys [status] :as dt}]
                                        (when (= status "published")
                                          dt))
                                      decision-trees)
        {published-data :data} (use-query (queries/fetch-decision-tree-query
                                           {:advertiser-id advertiser-id
                                            :adset-id adset-id
                                            :decision-tree-id (:id published-decision-tree)}))
        {draft-data :data} (use-query (queries/fetch-decision-tree-query
                                       {:advertiser-id advertiser-id
                                        :adset-id adset-id
                                        :decision-tree-id (:id draft-decision-tree)}))
        activation-processing (queries/is-decisision-tree-processing published-data)
        available-nodes (use-available-nodes)

        properties-context (use-properties-context available-nodes)
        node-type->explainer (validation/use-node-type->explainer properties-context
                                                                  available-nodes)]
    ($ decision-trees-context
       {:value {:is-trees-query-success isSuccess
                :is-trees-query-stale isStale
                :draft (assoc draft-decision-tree
                              :has-newer-revisions (has-newer-revisions? draft-data)
                              :has-archived-variants (has-archived-variants? draft-data))
                :published (assoc published-decision-tree
                                  :has-newer-revisions (has-newer-revisions? published-data)
                                  :has-archived-variants (has-archived-variants? published-data))
                :is-editor-readonly (nil? (:id draft-decision-tree))
                :activation-processing activation-processing
                :node-type->explainer node-type->explainer
                :available-nodes available-nodes
                :properties-context properties-context}}

       children)))
